import "./Auth.css"
import { useState } from "react";
import LoginForm from "../../components/auth/Login";
import SignupForm from "../../components/auth/Signup";

export default function Auth() {
  const [isLogin, setIsLogin] = useState(true);

  return (
    <div className="authContainer">
      <div className="authFormSection">
        {isLogin ? <LoginForm /> : <SignupForm />}
      </div>
      <div className="authToggleSection">
        <p>
          {isLogin ? (
            <>
              Don’t have an account?{" "}
              <button onClick={() => setIsLogin(false)}>Sign Up</button>
            </>
          ) : (
            <>
              Already have an account?{" "}
              <button onClick={() => setIsLogin(true)}>Login</button>
            </>
          )}
        </p>
      </div>
    </div>
  );
}
